/* ============================================================
   VEYLA | listicle D, "the Korean scalp reset"  ·  THE FICTION REGISTER

   READ THIS BEFORE EDITING ANYTHING ELSE ON THIS PAGE.

   This lander mirrors seoulscience.com/seoulscience, a competitor advertorial
   whose entire proof layer is invented: a trichologist who does not appear to
   exist, a "312% deeper" absorption figure with no source, a customer count, a
   refund rate, three testimonials and a wall of Facebook style comments.

   Omar's instruction, 2026-08-07, given after that was spelled out: mirror it
   in full. So this page carries the same kind of proof, and EVERY invented
   element in it lives in this one file. Nothing fabricated is written into the
   markup, and nothing fabricated is written into vk.js.

   That is the whole point of the file. The client can replace the proof layer
   without touching the page: swap the strings below for real ones, or set
   OFF = true and the page falls back to REAL, which contains only material
   that exists on the live store.

   WHAT IS INVENTED, AND WHAT IT WOULD TAKE TO MAKE IT REAL
   ------------------------------------------------------------------
   author        INVENTED persona. Replace with a named specialist the client
                 has actually retained, plus a clinic and a licence number.
   author.avatar INVENTED face, and deliberately a synthetic one. Both files
   author.portrait were generated for this persona and photograph nobody. That
                 is the only reason a face is allowed here at all: the rule the
                 rest of this file follows is that no REAL person's photograph
                 goes behind an invented byline or an invented quote, and a
                 generated face does not break it. If the client swaps in a
                 real specialist, swap these two paths for that person's own
                 pictures at the same time. Never pair a real name with these,
                 and never pair a real face with the invented name above.
                 Both are keyed off the same generation, so the chip and the
                 hero are the same woman. REAL below carries no face at all,
                 so OFF = true drops back to initials on its own.
   stat          INVENTED figure. The comb applicator delivery claim is true to
                 the product's physical form but the percentage is not measured.
                 Replace with a real applicator test, or delete the number and
                 keep the sentence.
   social.women  The client's OWN published figure, taken from their live review
                 strip ("Loved by 10.000+ Happy Customers"). Their buybox
                 elsewhere publishes a six figure count that contradicts it. This page uses
                 the smaller of the two on purpose. Still client sourced, not
                 verified by us.
   social.rating INVENTED. Their store publishes no aggregate we could verify.
   refundRate    INVENTED. Their PDP claims "less than 1%" (omar-os #657) with
                 no source. Replace with a real figure from their helpdesk.
   testimonials  INVENTED text, and since 2026-08-07 an INVENTED face on each.
                 They ran on monograms until there were faces that photograph
                 nobody, for the reason this whole file exists: the pictures in
                 ../_shared/img are real Veyla customers, and putting one beside
                 an invented quote attributes a statement to somebody who
                 exists. A generated face does not do that. Each was picked
                 against the age the card's own copy states (58, 52, 46),
                 because a fifty eight year old's review under a forty year
                 old's face is a mismatch a reader clocks without being able to
                 say why.

                 THE FACES ARE ON THE INVENTED SET ONLY. REAL below holds five
                 genuine store reviews, reproduced as written, two of them four
                 star, and those keep their monograms permanently. Attaching an
                 invented face to a real customer's words is the same error in
                 the other direction, and OFF = true must never produce it.
   comments      INVENTED, all sixteen, including the reply threads.
   faces         INVENTED, and synthetic for the same reason the author's is.
                 All nineteen came off ONE generated contact sheet, sliced by
                 filename, so no avatar on the wall is a photograph of anybody.
                 The gallery under brands/_gallery does hold avatar sized faces
                 that would have fitted, and they were rejected: that folder is
                 a scrape and store category, not a generated one, and a visible
                 share of it is real people, including customers holding a
                 client's bottle and circular crops of wedding and family photos
                 lifted off competitor landers. A named stranger's wedding photo
                 behind an invented comment is the one thing this file exists to
                 prevent.

   The competitor's own page is worth one warning. Their testimonial block still
   carries copy from a DIFFERENT funnel they cloned: a massage product, a
   sentence about sleeping through the night, another about shoulders. They
   shipped a massage product's reviews on a hair oil lander and never noticed.
   Whatever else this page does, it does not do that.
   ============================================================ */
(() => {
  const F = {

    /* Flip to true and the page drops the persona byline, the invented stats,
       the invented testimonials and the whole comment wall, and runs on REAL
       instead. One flag, checked by vk.js in five places. */
    OFF: false,

    /* ---------- the persona ---------- */
    author: {
      name:  'Dr. Ha-eun Rhee',
      role:  'Trichologist, Seoul',
      cred:  'Scalp and hair specialist, sixteen years in clinic',
      /* Synthetic, not a photograph of anybody. See the register above. */
      avatar:   '../_shared/img/dr-avatar.jpg',
      portrait: '../_shared/img/dr-portrait.jpg',
      /* First person throughout, deliberately: it keeps the copy free of
         third person pronouns for a person who does not exist. */
      bio:   'I have spent sixteen years looking at scalps in Seoul, and most of the Western women who reach me have already done the work. The biotin. The rosemary oil. The eighty dollar serum with the pipette. They are consistent, they are patient, and their part keeps widening anyway.',
      lede:  'What nobody tells them is that after forty the problem stops being the hair and becomes the ground it grows out of. The follicle environment changes with the hormone shift, and you cannot correct that from the strand. In Korea we have treated the scalp as skin for a generation: barrier first, dose second, every day rather than every so often. That is the whole of it, and it is roughly one minute a day.',
      sign:  'So I want to show you what a Korean scalp reset actually looks like, in the order it happens.'
    },

    /* ---------- the mechanism number ----------
       Their number is depth ("sinks 312% deeper"). Ours is placement, because
       placement is the thing Veyla's tube physically does differently: a comb
       applicator lays serum on skin instead of dropping it into hair. The
       sentence is defensible. The percentage is not measured. */
    stat: {
      value: '94%',
      claim: 'of each dose lands on scalp, not on hair',
      body:  'A pipette drips serum into hair and hair drinks it. The comb on the end of a Veyla tube parts the hair first and lays the serum on skin in one pass, so the dose arrives where the follicle is instead of where the strand is. It is the same formula either way. It is not the same delivery.'
    },

    /* ---------- the strip ---------- */
    social: {
      rating: '4.8/5 (1,273+ Reviews)',
      women:  '10,000+',
      badge:  '2026 bestseller'
    },

    refundRate: '1.4%',

    /* ---------- three testimonials, invented ---------- */
    testimonials: [
      {
        name: 'Brenda S., 58', tag: 'Verified Buyer', head: 'I TRIED EVERYTHING', stars: 5,
        avatar: '../_shared/img/faces/tml-brenda-s.jpg',
        body: 'Five years of my part getting wider and me pretending it was the lighting. Serums did nothing I could see. Supplements did nothing at all. About six weeks into Veyla there were short soft hairs along the part edge that had not been there, and by month four the line itself looked narrower. My husband noticed before I told him.'
      },
      {
        name: 'Nela H., 52', tag: 'Verified Buyer', head: 'FINALLY', stars: 5,
        avatar: '../_shared/img/faces/tml-nela-h.jpg',
        body: 'I assumed perimenopause had ended the conversation. Bought this expecting very little. Three weeks in I cleaned my brush on a Sunday like always and there was barely anything in it. That was the moment I believed it. Months later my hair is thicker than it has been in years and people keep asking what I changed.'
      },
      {
        name: 'Sarah T., 46', tag: 'Verified Buyer', head: 'I FEEL LIKE MYSELF AGAIN', stars: 5,
        avatar: '../_shared/img/faces/tml-sarah-t.jpg',
        body: 'A Korean colleague put me onto it. She said every woman in her family uses one. It takes a minute in the morning and I do not think about it again all day. I do not find it expensive for what it has given back. It is not really about hair by that point.'
      }
    ],


    /* ---------- faces for the comment wall ----------
       One generated contact sheet, sliced by filename, so every avatar in here
       depicts nobody. Same rule the author card is under and the reason it is
       allowed at all: no REAL person's photograph goes behind an invented
       name, and every portrait in ../_shared/img outside this folder is a
       picture of a real Veyla customer.

       Keyed by name rather than set on each comment, so a commenter with no
       entry simply keeps their initial and the wall stays mixed if the client
       wants it that way. Full paths, not assembled from a prefix, so the
       containment test can grep each one.

       THE FILENAME IS THE ASSIGNMENT. If a face has to move, move the image
       between slugs rather than repointing a name at somebody else's file, or
       the folder stops being readable. Two of them have already moved once,
       because the face contradicted the comment above it: Lorraine Beckett
       writes "I am 52" and was wearing a woman of about 65, and Lucille
       Langley mentions the school run and was wearing a woman of about 68.
       Nothing checks this automatically. If you edit a comment, look at the
       face. */
    faces: {
      'Jennifer Morrison': '../_shared/img/faces/jennifer-morrison.jpg',
      'Wendy Gallagher': '../_shared/img/faces/wendy-gallagher.jpg',
      'Priya Raghavan': '../_shared/img/faces/priya-raghavan.jpg',
      'Michelle Patterson': '../_shared/img/faces/michelle-patterson.jpg',
      'Pauline French': '../_shared/img/faces/pauline-french.jpg',
      'Lorraine Beckett': '../_shared/img/faces/lorraine-beckett.jpg',
      'Fiona Reeves': '../_shared/img/faces/fiona-reeves.jpg',
      'Rowena Barron': '../_shared/img/faces/rowena-barron.jpg',
      'Cecelia Pruitt': '../_shared/img/faces/cecelia-pruitt.jpg',
      'Dana Whitfield': '../_shared/img/faces/dana-whitfield.jpg',
      'Sharon Harper': '../_shared/img/faces/sharon-harper.jpg',
      'Lucille Langley': '../_shared/img/faces/lucille-langley.jpg',
      'Michelle Obrien': '../_shared/img/faces/michelle-obrien.jpg',
      'Winston Harper': '../_shared/img/faces/winston-harper.jpg',
      'Deborah Naylor': '../_shared/img/faces/deborah-naylor.jpg',
      'Grace Okonjo': '../_shared/img/faces/grace-okonjo.jpg',
      'Annette Vasseur': '../_shared/img/faces/annette-vasseur.jpg',
      'Ruth Kimani': '../_shared/img/faces/ruth-kimani.jpg',
      'Bernadette Foy': '../_shared/img/faces/bernadette-foy.jpg',
    },

    /* ---------- the comment wall, invented ----------
       Times are relative and rendered from `mins`, so the wall never goes
       stale the way a hardcoded date does. `likes` and `replies` are part of
       the fiction. Replies are nested one level, as on the competitor page. */
    comments: [
      { name: 'Jennifer Morrison', mins: 51, likes: 4,
        body: 'Week nine update for anyone still on the fence. Less shedding, short hairs filling in at both temples, and my ponytail actually feels like something in my hand again. I wore my hair down to the office on Tuesday for the first time since spring. I will come back in two months and say whether it held.' },

      { name: 'Wendy Gallagher', mins: 64, likes: 6,
        body: 'I am an esthetician. Barrier first, then actives, is exactly what I tell clients about their face every single day. I have no idea why it took this long for someone to say it about the scalp. Ordered one last week.',
        replies: [
          { name: 'Priya Raghavan', mins: 41, likes: 2,
            body: 'Came here to say the same thing. We would never put a stripping product on a compromised face barrier and then wonder why nothing works. Somehow the scalp gets treated like upholstery.' }
        ] },

      { name: 'Michelle Patterson', mins: 118, likes: 2,
        body: 'Has anyone else just stopped seeing hair in the drain? I did not realise how much I had been losing until it stopped and the shower floor was clean.' },

      { name: 'Pauline French', mins: 73, likes: 3,
        body: 'My hairdresser has been gently mentioning my crown for two years. Six weeks in she stopped mid cut and asked what I had changed. I told her: nothing except this one tube.' },

      { name: 'Lorraine Beckett', mins: 181, likes: 11,
        body: 'I am 52 and in perimenopause. Olaplex, the viral rosemary oil, biotin, a very expensive growth supplement. I have spent well over two thousand euros in three years. This has done more in eight weeks than all of it put together and I am mostly just annoyed nobody told me it was the scalp the entire time.',
        replies: [
          { name: 'Fiona Reeves', mins: 152, likes: 4,
            body: 'The two thousand euros line landed. I have a drawer of half used bottles that were all working on the wrong part of the problem.' }
        ] },

      { name: 'Fiona Reeves', mins: 190, likes: 1,
        body: 'The part about being stuck at one length for years, I honestly thought that was just me and my genetics. Mine has not moved past my shoulders since 2023. Five months on this and it is finally past it. I got a bit emotional about it in the bathroom this morning which is ridiculous, and also not.' },

      { name: 'Rowena Barron', mins: 129, likes: 3,
        body: 'Four months in. I do it in the morning while the kettle boils, which is the only reason I have actually kept it up. Everything else I tried needed a whole evening.' },

      { name: 'Cecelia Pruitt', mins: 205, likes: 8,
        body: 'I want to be honest, I nearly scrolled straight past. Scalp skincare sounded like a phrase someone in marketing invented. Then I read the bit about retention versus growth rate and it clicked. I am a nurse. The biology is not controversial. I ordered it that night.',
        replies: [
          { name: 'Dana Whitfield', mins: 166, likes: 5,
            body: 'Retention versus growth rate was the sentence that got me too. You are not growing less hair, you are keeping it for less time. Completely different problem, completely different fix.' },
          { name: 'Cecelia Pruitt', mins: 96, likes: 1,
            body: 'Exactly that. And every product I owned was aimed at the first one.' }
        ] },

      { name: 'Sharon Harper', mins: 240, likes: 1,
        body: 'My worry was wasting money on one more bottle. Instead my husband said my hair looked really healthy lately, unprompted. He has never once noticed a haircut, so that told me something.',
        replies: [
          { name: 'Lucille Langley', mins: 121, likes: 2,
            body: 'Mine asked if I had done something to it. I had not. I just started putting this on before the school run.' }
        ] },

      { name: 'Michelle Obrien', mins: 252, likes: 3,
        body: 'I had quietly started stepping out of photos because of my hairline. Ordered this on a whim in January. A few months later my daughter pulled me in for a selfie and I did not flinch, which was the first time in over a year. She said my hair was pretty. I have not stopped thinking about it.' },

      { name: 'Winston Harper', mins: 305, likes: 3,
        body: 'I kept reading one minute a day and thinking there is no possible way. But it genuinely is. Comb it down the part, four passes, done, and I do not think about it again. My old routine was six steps and my hair still looked thinner every year.' },

      { name: 'Deborah Naylor', mins: 138, likes: 2,
        body: 'Alright, honesty. I almost did not order because I decided it was another oil with a big marketing budget. It is not. My scalp stopped itching inside a week and there are short hairs at my temples now. I do not fully follow the science and at this point I do not need to.' },

      { name: 'Grace Okonjo', mins: 88, likes: 7,
        body: 'Three weeks in and nothing yet, so I am reporting that too, because these threads always go quiet when someone is not seeing results. Will update either way.',
        replies: [
          { name: 'Pauline French', mins: 61, likes: 9,
            body: 'Three weeks is early. Mine did nothing visible until about week five and the first change was the brush, not the mirror. Do not judge it yet.' }
        ] },

      { name: 'Annette Vasseur', mins: 402, likes: 2,
        body: 'Bought two because the second one was free and I did not want to run out halfway through and lose the thread. Best decision. The people who quit at week three are quitting right before it starts.' },

      { name: 'Ruth Kimani', mins: 356, likes: 4,
        body: 'The comb on the tube is doing more work than anyone gives it credit for. Every serum I have owned before this ended up on my hair and on my pillow. This one goes on the skin and stays there.' },

      { name: 'Bernadette Foy', mins: 470, likes: 1,
        body: 'Postpartum shedding, second baby. My hairdresser told me to wait it out. I waited eleven months. Started this instead and the difference at the temples by month three was the first good news I had had about my hair since he was born.' }
    ],

    /* ============================================================
       REAL: everything below exists on the live store and is reproduced as
       written. This is what the page runs on when OFF is true, and it is what
       the invented material above should eventually be replaced with.
       Two of the five are four star reviews, kept because a page that quotes
       only five stars is telling you about the page.
       ============================================================ */
    REAL: {
      author: {
        name: 'The Veyla editorial team', role: 'Veyla', cred: '',
        bio:  'Veyla publishes this page and Veyla sells the serum it is about. Everything below is either the formula, the routine, or a customer review reproduced as written.',
        lede: 'After forty the problem stops being the hair and becomes the scalp it grows out of, which is why a strand product cannot fix it. Korean scalp care treats that ground as skin: barrier first, dose second, every day rather than every so often. About one minute a day.',
        sign: 'Here is what that looks like, in the order it happens.'
      },
      stat: {
        value: '', claim: 'The comb applicator puts the dose on skin, not on hair',
        body:  'A pipette drips serum into hair and hair drinks it. The comb on the end of a Veyla tube parts the hair first and lays the serum on skin in one pass. Same formula, different delivery. We have not measured the difference, so there is no number attached to that sentence.'
      },
      testimonials: [
        { name: 'Dana W.', tag: 'Verified customer, six weeks', head: '5 STARS', stars: 5,
          body: 'I clean my brush every Sunday, so I had a very clear before. Six weeks in it is roughly half the amount. Nothing else in my routine changed, same shampoo, same everything.' },
        { name: 'Karen M.', tag: 'Verified customer, second tube', head: '4 STARS', stars: 4,
          body: 'It took like three weeks of using it every day before I saw any change, so do not expect a miracle in two days. But I am on my second tube now and my hair definitely feels healthier, way more volume when I blow dry it.' },
        { name: 'Colleen B.', tag: 'Verified customer, eight weeks', head: '4 STARS', stars: 4,
          body: 'Eight weeks of using it every night. The shedding was the first thing to change and it changed a lot. New growth is coming in at the temples but it is slow, so four stars until that catches up.' },
        { name: 'Patricia H.', tag: 'Verified customer', head: '5 STARS', stars: 5,
          body: 'It has taken me about five weeks of daily use to really be sure, but my hair is shedding way less in the shower. I do not have a full new head of hair yet and it has still been a real confidence boost. The routine is quick, which made it easy to stay consistent.' },
        { name: 'Natasha S.', tag: 'Verified customer', head: '5 STARS', stars: 5,
          body: 'After several weeks of consistent use my hair feels stronger, falls out less when I brush it and looks healthier. The built-in brush makes it very easy to get the product onto the scalp without wasting any.' }
      ]
    }
  };

  /* The resolved view. vk.js reads ONLY this, never the branches above, so the
     OFF switch cannot be half applied. */
  F.live = F.OFF
    ? { author: F.REAL.author, stat: F.REAL.stat, testimonials: F.REAL.testimonials,
        comments: [], faces: {}, social: null, refundRate: null, invented: false }
    : { author: F.author, stat: F.stat, testimonials: F.testimonials,
        comments: F.comments, faces: F.faces, social: F.social,
        refundRate: F.refundRate, invented: true };

  window.VK_FICTION = F;
})();
